export default __webpack_public_path__ + "static/media/delivery_dining.80163946.svg";